module.exports = __webpack_public_path__ + "static/media/booked_active.dee244f6.svg";